import { render, staticRenderFns } from "./contentMyCourse.vue?vue&type=template&id=31b09194&"
import script from "./contentMyCourse.vue?vue&type=script&lang=js&"
export * from "./contentMyCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports